module.exports = __webpack_public_path__ + "static/media/trunkbgt.cae3bb9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/trunkbgt.png
// module id = 1140
// module chunks = 0